<template>
  <div class="text-center">
    <v-icon
      :color="safeResult.success ? 'success' : 'error'"
      size="64"
      class="mb-4"
    >
      {{ safeResult.success ? 'mdi-check-circle' : 'mdi-alert-circle' }}
    </v-icon>
    
    <h3 class="headline mb-4">
      {{ safeResult.success ? 'Tenancy Created Successfully!' : 'Failed to Create Tenancy' }}
    </h3>
    
    <p class="text-subtitle-1 mb-6">
      {{ safeResult.message }}
    </p>
    
    <div v-if="safeResult.success && safeResult.tenancyId" class="mb-6">
      <v-chip color="primary" outlined>
        Tenancy ID: {{ safeResult.tenancyId }}
      </v-chip>
    </div>
    
    <v-row justify="center">
      <v-col cols="auto">
        <v-btn
          color="primary"
          @click="$emit('new-tenancy')"
        >
          Create Another Tenancy
        </v-btn>
      </v-col>
      <v-col cols="auto">
        <v-btn
          outlined
          @click="$emit('finish')"
        >
          View Tenancies
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'CompleteStep',
  
  props: {
    result: {
      type: Object,
      default: () => ({
        success: false,
        message: '',
        tenancyId: null
      })
    }
  },
  
  computed: {
    safeResult() {
      return this.result || {
        success: false,
        message: '',
        tenancyId: null
      }
    }
  }
}
</script>